import axios, { AxiosError } from "axios";
import { AppDispatch } from "../ReduxToolkit/Store";
import { AnyAction } from "@reduxjs/toolkit";

//For Build
// const baseURL = process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:8000";
const baseURL =
  process.env.REACT_APP_API_BASE_URL || "https://codegen-hris-api.site";

const api = axios.create({
  baseURL,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

/**
 * Sets up a response interceptor to handle 401 Unauthorized errors globally.
 */
export const setupInterceptors = (
  dispatch: AppDispatch,
  logoutAction: () => AnyAction,
) => {
  api.interceptors.response.use(
    (response) => response,
    async (error: AxiosError) => {
      const originalRequest: any = error.config;

      if (error.response?.status === 401 && !originalRequest?._retry) {
        originalRequest._retry = true;

        try {
          const refreshToken = localStorage.getItem("refresh_token");
          if (!refreshToken) throw new Error("No refresh token");

          // Call refresh endpoint
          const refreshRes = await axios.post(
            `${process.env.REACT_APP_API_BASE_URL}/api/auth/refresh`,
            { refresh_token: refreshToken }, // send in body
          );

          // Save new access token
          const newToken = (refreshRes.data as any).access_token;
          localStorage.setItem("access_token", newToken);

          // Retry original request with new token
          originalRequest.headers.Authorization = `Bearer ${newToken}`;
          return api(originalRequest);
        } catch (refreshError) {
          // Refresh failed → logout
          localStorage.removeItem("access_token");
          localStorage.removeItem("refresh_token");
          dispatch(logoutAction());
          return Promise.reject(refreshError);
        }
      }

      return Promise.reject(error);
    },
  );
};

export default api;
